class ProgressBarController {
    static CreateAnimatedCircleProgressBar(element, max, achieved, duration, color, easing, counterFontSize, counterPrefix, counterSuffix) {
        const bar = new ProgressBar.Circle(`#${element.id}`, { // eslint-disable-line no-undef
            color,
            // This has to be the same size as the maximum width to
            // prevent clipping
            strokeWidth: 4,
            trailWidth: 1,
            easing,
            duration,
            text: {
                style: {
                    position: 'absolute',
                    left: '50%',
                    top: '50%',
                    padding: 0,
                    margin: 0,
                    transform: 'translate(-50%, -50%)',
                    width: '100%',
                    'text-align': 'center',
                },
                autoStyleContainer: false,
            },
            from: { color, width: 1 },
            to: { color, width: 4 },
            // Set default step function for all animate calls
            step(state, circle) {
                circle.path.setAttribute('stroke', state.color);
                circle.path.setAttribute('stroke-width', state.width);

                const value = Math.round(circle.value() * max);
                if (value === 0) {
                    circle.setText('');
                }
                else {
                    circle.setText(counterPrefix + value + counterSuffix);
                }
            },
        });
        bar.text.style.fontSize = `${counterFontSize}px`;
        return bar;
    }

    static CreateAnimatedSemiCircleProgressBar(element, max, achieved, duration, color, easing, counterFontSize, counterPrefix, counterSuffix) {
        const bar = new ProgressBar.SemiCircle(`#${element.id}`, { // eslint-disable-line no-undef
            strokeWidth: 4,
            color,
            // trailColor: color,
            trailWidth: 1,
            easing,
            duration,
            svgStyle: null,
            text: {
                style: {
                    position: 'absolute',
                    left: '50%',
                    top: 'auto',
                    padding: 0,
                    margin: 0,
                    transform: 'translate(-50%, 50%)',
                    width: '100%',
                    'text-align': 'center',
                },
                value: '',
                alignToBottom: false,
            },
            from: { color },
            to: { color },
            // Set default step function for all animate calls
            step(state, progressBar) {
                const tempProgressBar = progressBar;
                tempProgressBar.path.setAttribute('stroke', state.color);
                const value = Math.round(tempProgressBar.value() * max);
                if (value === 0) {
                    tempProgressBar.setText('');
                }
                else {
                    tempProgressBar.setText(counterPrefix + value + counterSuffix);
                }
                tempProgressBar.text.style.color = state.color;
            },
        });
        bar.text.style.fontSize = `${counterFontSize}px`;
        return bar;
    }

    static CreateAnimatedLineProgressBar(element, max, achieved, duration, color, easing, counterFontSize, counterPrefix, counterSuffix) {
        const bar = new ProgressBar.Line(`#${element.id}`, { // eslint-disable-line no-undef
            strokeWidth: 4,
            color,
            trailColor: color,
            trailWidth: 1,
            easing,
            duration,
            svgStyle: { width: '100%', height: '100%' },
            text: {
                style: {
                    position: 'absolute',
                    right: '0',
                    top: '30px',
                    padding: 0,
                    margin: 0,
                    transform: null,
                },
                autoStyleContainer: false,
            },
            from: { color },
            to: { color },
            // Set default step function for all animate calls
            step(state, progressBar) {
                const tempProgressBar = progressBar;
                tempProgressBar.path.setAttribute('stroke', state.color);
                const value = Math.round(tempProgressBar.value() * max);
                if (value === 0) {
                    tempProgressBar.setText('');
                }
                else {
                    tempProgressBar.setText(counterPrefix + value + counterSuffix);
                }
                tempProgressBar.text.style.color = state.color;
            },
        });
        bar.text.style.fontSize = `${counterFontSize}px`;
        return bar;
    }
}

window.ProgressBarController = ProgressBarController;
export default ProgressBarController;
